import styled from 'styled-components';

const EmptyThankLottieStyle = styled.div`
	--sizeLottie: var(--sp24x);
	--sizeLottieEmpty: calc(var(--sizeLottie) - var(--sp5x));

	.lottie-wrap {
		display: flex;
		width: fit-content;
		height: var(--sizeLottieEmpty);

		svg {
			max-width: 100% !important;
			width: auto !important;
		}
	}

	&.empty {
		.lottie-wrap {
			height: var(--sizeLottie);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeLottie: var(--sp24x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeLottie: var(--sp24x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeLottie: var(--sp22x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeLottie: var(--sp22x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeLottie: var(--sp18x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeLottie: var(--sp20x);
	}
`;
export default EmptyThankLottieStyle;
